import React, { useState, useEffect } from "react";
import "./cargar.scss";
import axios from "axios";
import Swal from "sweetalert2";
import Select from "@mui/material/Select";
import { IconButton } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import Resizer from "react-image-file-resizer";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

const URL_CARNET = process.env.REACT_APP_APIURL;

const Cargar = () => {
  const [loading, setLoading] = useState(true);
  const [foto, setFoto] = useState("");
  const [datosEstudiante, setDatosEstudiantes] = useState({});
  const [tiposCarnet, setTiposCarnet] = useState("");
  const [inToken, setInToken] = useState("");
  const [classForm, handleClassForm] = useState(
    "wrap-container min-height-modal right-panel-active"
  );
  const [data, setData] = useState({
    tipoCarnet: "",
    carnet: "",
    email: "",
    sede: 1,
  });

  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };

  const { tipoCarnet, carnet, email, sede } = data;
  const { Apellidos, Nombres } = datosEstudiante;

  useEffect(() => {
    if (loading) {
      async function fetchData() {
        try {
          const response = await axios.get(URL_CARNET + "/fechasProceso");
          const listaprocesos = response?.data?.listaProcesos || [];
          setTiposCarnet(listaprocesos);
        } catch (error) {
          Swal.fire({
            title:
              '<strong style="color:#EDEEEF; letter-spacing: 1px;"> ERROR </strong>',
            icon: "error",
            html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Al parecer existe un problema intenta mas tarde...</font></p> ',
            background: "#1E4775",
            showConfirmButton: false,
            showCloseButton: true,
          });
        }
      }
      fetchData();
      setLoading(false);
    }
  }, [loading]);

  const buscarInformacionCarnet = async (e) => {
    const carnetBusqueda = e?.target?.value || "";
    setDatosEstudiantes({ Apellidos: null, Nombres: null });
    setData({
      ...data,
      carnet: carnetBusqueda.substring(0, carnetBusqueda.length),
    });

    const persona = await buscarPersona(carnetBusqueda, tipoCarnet, sede);
    if (persona?.Code !== 200) error(persona?.Message);
    else setDatosEstudiantes(persona);
  };

  const cambiarFormulario = (e) => {
    // identifica si se dio click en boton o a
    const origen = e?.target?.localName;
    let accion = "";
    if (origen == "a") {
      accion = e?.target?.name;
    } else {
      accion = e?.target?.value;
    }

    if (accion === "showtoken") {
      handleClassForm("wrap-container min-height-modal right-panel-active");
    } else {
      handleClassForm("wrap-container min-height-modal");
    }
  };

  const handleFoto = (e) => {
    if (e?.target?.files?.[0]) setFoto(e.target.files[0]);
  };

  const buscarPersona = async (Carnet, TipoCarnet, IdSede) => {
    try {
      const response = await axios.post(URL_CARNET + "/searchPersona", {
        Carnet,
        TipoCarnet,
        IdSede,
      });
      return response?.data || [];
    } catch (error) {
      return error?.response?.data;
    }
  };

  const error = (msg, reload = false) => {
    Swal.fire({
      title:
        '<strong style="color:#EDEEEF; letter-spacing: 1px;"> LO SENTIMOS </strong>',
      icon: "error",
      html: `<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">${msg}</font></p> `,
      background: "#1E4775",
      showConfirmButton: false,
      showCloseButton: true,
    }).then(function () {
      if (reload) {
        window.location.reload(true);
      }
    });
  };

  const generarBase64 = (file, HD = false) => {
    let maxWidth = 300;
    let maxHeight = 300;
    const compressFormat = "JPEG";
    let quality = 80;
    const rotation = 0;
    const outputType = "base64";

    if (HD) {
      quality = 100;
      maxWidth = 2000;
      maxHeight = 2000;
    }

    return new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        maxWidth,
        maxHeight,
        compressFormat,
        quality,
        rotation,
        (uri) => resolve(uri),
        outputType
      );
    });
  };

  const requestUpdatePicture = async (
    tipoCarnet,
    datosEstudiante,
    datosIngresados,
    foto
  ) => {
    const first = Math.random().toString(36).substr(2);
    const token = first.substr(0, 8).toUpperCase();

    const { carnet, email, sede } = datosIngresados;
    const {
      Apellidos,
      IdFacultad,
      NombreCarrera,
      NombreFacultad,
      Nombres,
      NombreMaestria,
      Direccion,
      Cargo,
      Dui,
      TipoContrato,
    } = datosEstudiante;
    switch (tipoCarnet) {
      case "JOVENES TALENTO":
        return {
          Foto: foto,
          Token: token,
          IdSede: sede,
          TipoCarnet: tipoCarnet,
          Carnet: token,
          Email: "",
          Nombres,
          Apellidos,
          IdFacultad: "",
          NombreFacultad: "",
          NombreCarrera: "",
        };
      case "CMAC":
        return {
          Foto: foto,
          Token: token,
          IdSede: sede,
          TipoCarnet: tipoCarnet,
          Carnet: token,
          Email: email,
          Nombres,
          Apellidos,
          IdFacultad: "",
          NombreFacultad: "",
          NombreCarrera: "",
        };

      case "PREGRADO":
        return {
          Foto: foto,
          Token: token,
          IdSede: sede,
          TipoCarnet: tipoCarnet,
          Carnet: carnet,
          Email: email,
          Nombres,
          Apellidos,
          IdFacultad,
          NombreFacultad,
          NombreCarrera,
        };

      case "EGRESADO":
        return {
          Foto: foto,
          Token: token,
          IdSede: sede,
          TipoCarnet: tipoCarnet,
          Carnet: carnet,
          Email: email,
          Nombres,
          Apellidos,
          IdFacultad,
          NombreFacultad,
          NombreCarrera,
        };

      case "POSTGRADO":
        return {
          Foto: foto,
          Token: token,
          IdSede: sede,
          TipoCarnet: tipoCarnet,
          Carnet: carnet,
          Email: email,
          Nombres,
          Apellidos,
          IdFacultad,
          NombreFacultad,
          NombreMaestria,
        };

      case "DOCENTE":
        return {
          Foto: foto,
          Token: token,
          IdSede: sede,
          TipoCarnet: tipoCarnet,
          Carnet: carnet,
          Email: email,
          Nombres,
          Apellidos,
          IdFacultad,
          NombreFacultad,
          TipoContrato,
          Dui,
        };

      case "EMPLEADO":
        return {
          Foto: foto,
          Token: token,
          IdSede: sede,
          TipoCarnet: tipoCarnet,
          Carnet: carnet,
          Email: email,
          Nombres,
          Apellidos,
          Direccion,
          Cargo,
          Dui,
        };

      default:
        return {};
    }
  };

  const sendPicture = async (e) => {
    const HD = ["EMPLEADO", "DOCENTE"].includes(tipoCarnet);
    const imgbase64 = await generarBase64(foto, HD);

    Swal.fire({
      title: "VISTA PREVIA",
      html: `<img id="qr-code2" src="${imgbase64}" width="210" height="240" alt="" /></br>
            <p class="pt-2" style="color:#000000; letter-spacing: 1px;"><font size="3">${Nombres} ${Apellidos}</font></p>`,
      confirmButtonText: "CONFIRMAR",
      showLoaderOnConfirm: true,
      cancelButtonText: "CANCELAR",
      showCancelButton: true,
      preConfirm: async () => {
        const datosenviar = await requestUpdatePicture(
          tipoCarnet,
          datosEstudiante,
          data,
          imgbase64
        );

        axios({
          url: URL_CARNET + "/sendPicture",
          method: "post",
          data: datosenviar,
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => {
            const { Code, Token, Message, Nombres, Apellidos } =
              response?.data || {};
            if (Code !== undefined) {
              if (Code === 200) {
                Swal.fire({
                  title: `<strong style="color:#EDEEEF; letter-spacing: 1px;">TOKEN: ${Token}</strong>`,
                  icon: "success",
                  html: `<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"><b>${Nombres} ${Apellidos}</b>, ${Message}</font></p>`,
                  background: "#1E4775",
                  showConfirmButton: false,
                  showCloseButton: true,
                }).then(function () {
                  window.location.reload(true);
                });
              } else {
                error(Message, true);
              }
            } else {
              error(
                "Al parecer existe un problema, por favor intenta mas tarde...",
                true
              );
            }
          })
          .catch((err) => {
            const { Message } = err?.response?.data;
            if (err.response !== undefined) {
              error(Message, true);
            } else {
              error("Al parecer existe un problema intenta mas tarde...", true);
            }
          });
      },
    });
  };

  const updatePicture = async (e) => {
    e.preventDefault();
    const buscarToken = await axios({
      url: URL_CARNET + "/searchToken",
      method: "post",
      data: { Token: inToken },
      headers: {
        "Content-Type": "application/json",
      },
    }).catch((error) => {
      const { response = {} } = error;
      Swal.fire({
        title: `<strong style="color:#EDEEEF; letter-spacing: 1px;">TOKEN: ${inToken} </strong>`,
        icon: "error",
        html: `<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"> ${response.data.Message} </font></p>`,
        background: "#1E4775",
        showConfirmButton: false,
        showCloseButton: true,
      }).then(function () {
        window.location.reload(true);
      });
    });

    const { Code, Token, Message, NombreCompleto, Descripcion, Update } =
      buscarToken?.data;

    if (Code === 203) {
      const { value: file } = await Swal.fire({
        title: `<strong style="color:#EDEEEF; letter-spacing: 1px;">TOKEN: ${Token} </strong>`,
        icon: "info",
        html: `<p align="justify" style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"><b> ${NombreCompleto} </b>, Debes actualizar la fotografia para continuar con el proceso de carnetización</font></p> <font color="white" align="justify" size="4"><ul><li> ${Descripcion} </li></ul></font">`,
        background: "#1E4775",
        confirmButtonText: "ACTUALIZAR FOTOGRAFIA",
        input: "file",
        inputPlaceholder: "Write something",
        inputAttributes: {
          id: "fileToUpload",
          accept: "image/*",
          multiple: "single",
        },
      });

      if (file) {
        const imgBase64 = await generarBase64(file[0]);
        Swal.fire({
          title: `<strong style="color:#EDEEEF; letter-spacing: 1px;">VISTA PREVIA</strong>`,
          html: `<img id="qr-code2" src="${imgBase64}"  width="210" height="240" alt=""><p style="color:#FFFFFF; letter-spacing: 1px;margin-top:15px"><font size="3"> ${NombreCompleto} </font></p>`,
          background: "#1E4775",
          confirmButtonText: "CONFIRMAR",
          showLoaderOnConfirm: true,
          cancelButtonText: "CANCELAR",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            axios({
              url: URL_CARNET + "/updatePicture",
              method: "post",
              data: { Foto: imgBase64, Token },
              headers: {
                "Content-Type": "application/json",
              },
            })
              .then((response) => {
                const flag = response.data.Code;
                if (flag !== undefined) {
                  let token = response.data.Token;
                  let message = response.data.Message;
                  if (flag === 200) {
                    let name = response.data.Nombres;

                    Swal.fire({
                      title: `<strong style="color:#EDEEEF; letter-spacing: 1px;">TOKEN: ${token} </strong>`,
                      icon: "success",
                      html: `<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"><b> ${name} </b>, ${message} </font></p> `,
                      background: "#1E4775",
                      showConfirmButton: false,
                      showCloseButton: true,
                    }).then(function () {
                      window.location.reload(true);
                    });
                  } else {
                    Swal.fire({
                      title: `<strong style="color:#EDEEEF; letter-spacing: 1px;">LO SENTIMOS </strong>`,
                      icon: "warning",
                      html: `<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"> ${message} </font></p> `,
                      background: "#1E4775",
                      showConfirmButton: false,
                      showCloseButton: true,
                    }).then(function () {
                      window.location.reload(true);
                    });
                  }
                } else {
                  Swal.fire({
                    title: `<strong style="color:#EDEEEF; letter-spacing: 1px;"> ERROR </strong>`,
                    icon: "error",
                    html: '<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3">Al parecer existe un problema, por favor intenta mas tarde...</font></p> ',
                    background: "#1E4775",
                    showConfirmButton: false,
                    showCloseButton: true,
                  }).then(function () {
                    window.location.reload(true);
                  });
                }
              })
              .catch((err) => {})
              .then((response) => response.json())
              .then((data) => Swal.insertQueueStep(data.ip))
              .catch(() => {
                Swal.insertQueueStep({
                  icon: "error",
                  title: "Unable to get your public IP",
                });
              });
          }
        });
      }
    } else {
      Swal.fire({
        title: `<strong style="color:#EDEEEF; letter-spacing: 1px;">TOKEN: ${Token} </strong>`,
        icon: "success",
        html: `<p style="color:#EDEEEF; letter-spacing: 1px;"><font size="3"> ${Message} </font></p>`,
        background: "#1E4775",
        showConfirmButton: false,
        showCloseButton: true,
      }).then(function () {
        window.location.reload(true);
      });
    }
  };

  const classFoto = foto ? "cargar-fotografia active" : "cargar-fotografia";

  return (
    <div className="wrap-modal max-width-modal">
      <div className={classForm}>
        <div className="form-container form-right">
          <div className="form ps-5 pe-5 pt-3">
            <div>
              <h3 className="text-center mb-4">CARNETÍZATE</h3>
              <FormControl variant="standard" fullWidth className="mb-2">
                <InputLabel id="tipo-carnet-label">
                  Selecciona el tipo de carn&eacute;
                </InputLabel>
                <Select
                  labelId="tipo-carnet-label"
                  id="tipoCarnet"
                  name="tipoCarnet"
                  value={tipoCarnet}
                  label="Age"
                  onChange={handleChange}
                >
                  {tiposCarnet &&
                    tiposCarnet.map((item) => {
                      return (
                        <MenuItem value={item.valor} key={item.valor}>
                          {item.etiqueta}
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
              <div className="mb-2">
                <TextField
                  fullWidth
                  id="carnet"
                  name="carnet"
                  label="Carn&eacute; *"
                  variant="standard"
                  autoComplete="off"
                  onBlur={buscarInformacionCarnet}
                />
              </div>
              <div className="mb-2">
                <TextField
                  fullWidth
                  id="nombres"
                  name="nombres"
                  label="Nombres *"
                  variant="standard"
                  disabled
                  value={Nombres || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <TextField
                  fullWidth
                  id="apellidos"
                  name="apellidos"
                  label="Apellidos *"
                  variant="standard"
                  disabled
                  value={Apellidos || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <TextField
                  fullWidth
                  id="email"
                  name="email"
                  label="Email *"
                  variant="standard"
                  value={email}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-12">
                <input
                  accept="image/*"
                  required
                  className="camera"
                  id="icon-button-file"
                  type="file"
                  onChange={(e) => handleFoto(e)}
                />
                <label
                  htmlFor="icon-button-file"
                  required
                  className={classFoto}
                >
                  Adjunta tu fotograf&iacute;a
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-camera-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z" />
                      <path d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4H2zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1zm9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0z" />
                    </svg>
                  </IconButton>
                </label>
              </div>
            </div>
            <div className="text-center">
              <button
                className="text-uppercase mt-3 boton lightBlue"
                id="signIn"
                value=""
                onClick={sendPicture}
              >
                Enviar
              </button>
            </div>

            <div className="ver-boton-consulta text-center">
              <h4>¿Ya tienes Token?</h4>
              <p>
                Si ya posees tu número de Token, puedes consultar tu proceso de
                carnetización aquí.
              </p>
              <button
                className="text-uppercase boton orange pb-3"
                id="signIn"
                value="showcontacto"
                onClick={cambiarFormulario}
              >
                Consultar
              </button>
            </div>
          </div>
        </div>
        <div className="form-container form-left">
          <form action="#" className="ps-5 pe-5 pt-3" onSubmit={updatePicture}>
            <h2>Token</h2>
            <p className="text-token-m">
              Si ya posees tu número de Token, puedes consultar tu proceso de
              carnetización aquí.
            </p>
            <TextField
              label="Ingresa tu n&uacute;mero de Token"
              required
              id="token"
              name="token"
              autoComplete="off"
              fullWidth={true}
              variant="standard"
              value={inToken}
              onChange={(e) => setInToken(e.target.value)}
            />
            <button
              className="text-uppercase mt-4 boton lightBlue"
              id="signIn"
              value=""
            >
              Continuar
            </button>
            <div className="text-center">
              <h3 className="mt-5 d-block d-md-none">¿No tienes Token?</h3>
              <p className="d-block d-md-none">
                Si no posees tu número de Token, completa el formulario para
                realizar tu proceso de carnetización.
              </p>
            </div>
            <a
              className="text-uppercase d-block d-md-none boton orange text-center noUnderline"
              id="btncontacto"
              value="showtoken"
              name="showtoken"
              onClick={cambiarFormulario}
            >
              CARNETÍZATE
            </a>
          </form>
        </div>
        <div className="overlay-container">
          <div className="overlay">
            <div className="overlay-panel overlay-left">
              <h1>¿Ya tienes Token?</h1>
              <p>
                Si ya posees tu número de Token, puedes consultar tu proceso de
                carnetización aquí.
              </p>
              <button
                className="text-uppercase boton orange"
                id="signIn"
                value="showcontacto"
                onClick={cambiarFormulario}
              >
                Consultar
              </button>
            </div>
            <div className="overlay-panel overlay-right">
              <h1>¿No tienes Token?</h1>
              <p>
                Si no posees tu número de Token, completa el formulario para
                realizar tu proceso de carnetización.
              </p>
              <button
                className="text-uppercase boton orange"
                id="btncontacto"
                value="showtoken"
                onClick={cambiarFormulario}
              >
                CARNETÍZATE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cargar;
